import { render, staticRenderFns } from "./PlanesTratamiento.vue?vue&type=template&id=376f84a2&"
import script from "./PlanesTratamiento.vue?vue&type=script&lang=js&"
export * from "./PlanesTratamiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports